module.exports = __webpack_public_path__ + "static/media/img-home1.52282180.jpg";